<script>
  import NavbarSuccess from "../NavbarSuccess.svelte";
  import { FormGroup, Label, Input, Button } from "sveltestrap";
  import { onMount, getContext } from "svelte";
  import axios from "axios";
  import { isEqual, isBefore, parse, format } from 'date-fns';

  let startDate = null;
  let endDate = null;
  let location = window.location.origin;
  let filter = 1;
  let staffArray = null;
  let staffId = '';
  let teamArray;
  let teamId = '';

  let validationResult = {
    isValid: true,
    message: ''
  };

  const PTOFilterType = {
    TEAM: 1,
    STAFF: 2,
  };

  const { showList, getUser } = getContext('hours');

  onMount(() => {
    getUserDetails()
      .then(getStaff)
      .then(getTeam)
      .then(() => {
        const user = getUser();
        if (user.Team === 100000005) {
          return;
        }

        if (user.IsTeamLead && !user.IsProjectManager) {
          teamId = user.Team;
          teamArray = teamArray.filter(e => +e.Value === teamId);
          staffId = user.ID;
          staffArray = staffArray.filter(e => +e.teamId === teamId);
        } else if (!user.IsProjectManager) {
          teamId = user.Team;
          teamArray = teamArray.filter(e => +e.Value === teamId);
          staffId = user.ID;
          staffArray = staffArray.filter(e => e.staffId === staffId);
        }

        if (!user.IsProjectManager && !user.IsTeamLead) {
          filter = PTOFilterType.STAFF;
        }
      });
  });

  function getStaff() {
    return axios
      .get("/timesheetapi/getstaff")
      .then(function(response) {
        staffArray = response.data.Result;
        staffId = staffArray[0].staffId;
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  function getTeam() {
    return axios
      .get("/JobBoardApi/GetTeams")
      .then(function(response) {
        teamArray = response.data;
        teamId = teamArray[0].Value;
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  function handleChangeStaff(e) {
    staffId = e.target.value;
  }

  function handleChangeTeam(e) {
    teamId = e.target.value;
  }

  function submit() {
    showList(startDate, endDate, staffId, teamId, filter);
  }

  function getTeamOfUser() {
    const user = getUser();
    if (!user) {
      return {
        id: -1,
        label: '',
      };
    }

    const team = !!teamArray && teamArray.find(e => e.Value === user.Team) || { Label: '' };

    return {
      id: user.Team,
      label: team.Label,
    };
  }

  function getUserDetails() {
    return new Promise(resolve => {
      let userDetails = getUser();
      if (!!userDetails) {
        resolve(userDetails);
      }

      let intervalId = setInterval(() => {
        let userDetails = getUser();
        if (!userDetails) {
          return;
        }

        clearInterval(intervalId);
        resolve(userDetails);
      }, 100);
    });
  }

  function validateForm() {
    validationResult = {
      isValid: true,
      message: '',
    };

    if (!isDateRangeHasValue()) {
      validationResult.isValid = false;
      validationResult.message = 'Start Date or End Date is empty';
    } else if (!isDateRangeValid()) {
      validationResult.isValid = false;
      validationResult.message = 'Date Range is invalid';
    }

    validationResult = validationResult;
  }

  function isDateRangeHasValue() {
    const isDateRangeHasValue = !!startDate && !!endDate;

    return isDateRangeHasValue;
  }

  function isDateRangeValid() {
    const from = document.querySelector('#start-date').valueAsDate;
    const to = document.querySelector('#end-date').valueAsDate;

    const isDateRangeValid = isEqual(from, to) || isBefore(from, to);

    return isDateRangeValid;
  }
</script>

<style>
  .hours-container {
    margin: 50px auto;
  }

  .hours-form-container {
    width: 40%;
    margin: 0 auto;
    border: 1px solid #b2bec3;
    border-radius: 5px;
  }

  .hours-form-body {
    padding: 20px 50px;
  }

  .hours-form-container input {
    width: 100%;
    margin: 10px 0px;
    padding: 10px;
    border: 1px solid #b2bec3;
    border-radius: 5px;
  }

  .hours-form-container button {
    background-color: #3498db;
    border: none;
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
    margin-top: 10px;
    margin-left: auto;
  }

  .hours-form-title {
    padding: 10px 15px;
    text-align: center;
    border-radius: 5px 5px 0px 0px;
    background-color: #dcdde1;
    border-bottom: 1px solid #b2bec3;
  }

  select {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #b2bec3;
    margin-bottom: 10px;
  }

  @media (max-width: 768px) {
    .hours-form-container {
      width: 60%;
    }
  }

  @media (max-width: 425px) {
    .hours-form-container {
      width: 100%;
    }
  }

  .validation-message {
    color: #fab1a0;
    margin-left: 0.5rem;
  }

</style>

<div class="hours-container">
  <div class="hours-form-container">
    <div class="hours-form-title">Generate Report</div>
    <div class="hours-form-body">
      <div style="display: flex">
        <span style="margin-right: 40px">Filter:</span>
        {#await getUserDetails()}
          &nbsp;
        {:then value}
          {#if value.IsProjectManager || value.IsTeamLead || value.Team === 100000005}
            <label>Team</label>
            <input
              type="radio"
              bind:group={filter}
              value={PTOFilterType.TEAM}
              style="width:15%; margin-top:7px" />
          {/if}
        {/await}
        <label>Staff</label>
        <input
          type="radio"
          bind:group={filter}
          value={PTOFilterType.STAFF}
          style="width:15%; margin-top:7px" />
      </div>
      {#if filter === PTOFilterType.TEAM}
        <select value={teamId} on:change={handleChangeTeam}>
          {#if teamArray != null}
            {#each teamArray as team}
              <option value={team.Value}>{team.Label}</option>
            {/each}
          {/if}
        </select>
      {:else if filter === PTOFilterType.STAFF}
        {#if staffArray !== null}
          <select value={staffId} on:change={handleChangeStaff}>
            {#each staffArray as staff}
              <option value={staff.staffId}>{staff.staffName}</option>
            {/each}
          </select>
        {/if}
      {/if}
      <br />
      Start Date:
      <input type="date" id="start-date" bind:value={startDate} max={format(new Date(), 'yyyy-MM-dd')} on:change={validateForm} />
      End Date:
      <input type="date" id="end-date" bind:value={endDate} max={format(new Date(), 'yyyy-MM-dd')} on:change={validateForm} />
      <Button color="primary" disabled={!validationResult.isValid} on:click={submit}>
        View
      </Button>
      <span class="validation-message">{validationResult.message}</span>
    </div>
  </div>
</div>
